import { render, staticRenderFns } from "./EquipmentInfo.vue?vue&type=template&id=19bbd904&scoped=true&"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js&"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentInfo.vue?vue&type=style&index=0&id=19bbd904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbd904",
  null
  
)

export default component.exports